import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      camper, // via graphql query
      logInCamper, // via mutation
      setModal // via redux actions
    } = props

    // perform GraphQL mutation
    const handleClickLogIn = e => {
      e.preventDefault()
      logInCamper({
        variables: {
          camperId: camper.id
        }
      })
    }

    const handleClickHelp = e => {
      e.preventDefault()
      setModal({ id: 'onlineHelp', open: true })
    }

    return (
      <WrappedComponent
        onClickLogIn={handleClickLogIn}
        onClickHelp={handleClickHelp}
        {...props}
      />
    )
  }
}

export default withEventHandlers
